import { h } from 'preact';

const Tab = ({ activeTab, handleTabClick, tab }) => (
  <button
    key={tab.id}
    className={`text-lg w-full gap-8 font-franklin text-24 ${activeTab === tab.id ? 'border-black-300 border-b-2 font-weight-bold' : ''}`}
    onClick={() => handleTabClick(tab.id)}
  >
    {tab.label}
  </button>
);

export default Tab;
